import { Box, Button, Grid, useDisclosure } from '@chakra-ui/react'
import React from 'react'

import { ChevronRight } from '../../icons'

export const BusinessDiscountsWrapper = ({ children }: { children: React.ReactNode }) => {
  const { isOpen, onToggle } = useDisclosure()

  return (
    <Grid
      sx={{
        justifyItems: 'start',
        w: '100%',
        p: 4,
        gap: 4,
        backgroundColor: 'gray.50',
        borderRadius: 'md',
      }}
    >
      <Button variant="link" sx={{ gap: 2 }} onClick={onToggle}>
        <ChevronRight style={{ transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)' }} />

        {isOpen ? 'Skrýt obchodní slevy' : 'Nastavit obchodní slevy'}
      </Button>

      <Box
        sx={{
          display: isOpen ? 'grid' : 'none',
          rowGap: 16,
          columnGap: 8,
          justifyContent: 'stretch',
          gridTemplateColumns: {
            base: '1fr',
            lg: '1fr 1fr',
          },
        }}
      >
        {children}
      </Box>
    </Grid>
  )
}
